module.exports = __webpack_public_path__ + "img/text-to-report.8468257b.jpg";